<div class="modal-overlay" (click)="closeClicked.emit()">
    <div class="modal-container">
        <div class="modal-menu">
            <button class="icon icon-close" (click)="closeClicked.emit()"></button>
        </div>
        <div class="modal-content">
            <ng-content></ng-content>
        </div>
    </div>
</div>
